/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, PopupRequest } from "@azure/msal-browser";
//import { getMSALCredentials } from "./api";

/* eslint-disable no-console */

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
// const response = await getMSALCredentials();
// console.log("response", response);
    
export const msalConfig: Configuration = {
    

    auth: {
        clientId: "67a33775-fc53-4d5c-9179-65f05c046e59",
        // clientId: "efa396a2-094c-4af1-8af3-c38d0dbbfa01",
        authority: "https://login.microsoftonline.com/" + "9254a937-5fd5-498b-bb69-6c84a4934d34",
        redirectUri: window.location.origin,
        //redirectUri:"https://127.0.0.1:5000"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};


/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // scopes: ["User.Read", "api://2780c98a-0a9e-41d7-ab21-6e4effbbbe2d/user_impersonation"],
    scopes: ["User.Read"],
    // extraScopesToConsent: [ "api://4d05247d-a46e-47c1-aaf5-cb17378f927a/user_impersonation"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
